import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { CobuStack, CobuText } from '@cobu/ui'
import type { Place } from '@cobu/types'
import { CATEGORY_META } from './categoryMeta'
import { Strings } from '../../constants/Strings'

/**
 * Embedded, tappable place card shown on a feed post that shares a Place
 * (PRD §15 / §8.5). The backend hydrates the full place object onto the feed
 * post, so this renders directly off it — no fetch. The post's type badge is
 * intentionally not rendered here (see review item #4).
 */
export function PlaceEmbedCard({ place }: { place: Place }) {
  const navigate = useNavigate()

  const categoryMeta = CATEGORY_META[place.category] ?? CATEGORY_META.food
  const CategoryIcon = categoryMeta.icon

  return (
    <CobuStack
      layout="horizontal"
      ai="center"
      gap="$3"
      p="$3"
      br="$3"
      bg="$backgroundSecondary"
      onPress={() => navigate(`/places/${place.uuid}`)}
    >
      <CobuStack w={36} h={36} br="$3" ai="center" jc="center" bg="$background">
        <CategoryIcon style={{ fontSize: 18 }} />
      </CobuStack>
      <CobuStack f={1}>
        <CobuText variant="body" fontWeight="600" fontSize="$2">{place.name}</CobuText>
        <CobuText variant="caption" color="$colorSecondary">{Strings.get().places.embed.tapToSee}</CobuText>
      </CobuStack>
      <ArrowForwardIcon style={{ fontSize: 16 }} />
    </CobuStack>
  )
}
